export class ModalidadBean {
         id:string;
          name:string;
          description:string;
          price:string;
          order:string;
          currency: string;
          enabled: string;
          usuarioModificaId: string
          constructor(){
            this.id="";
            this.name="";
            this.description="";
            this.price="";
            this.order="";
            this.currency="";
            this.enabled="";
            this.usuarioModificaId="";
          }
}
export class ModalidadBeanRequest {
    id:string;
     name:string;
     description:string;
     price:string;
     order:string;
     currency: string;
     enabled: string;
     usuarioModificaId: string     
}

